import React from "react";
import ReactDOM from "react-dom";

const LoadingOverlay = ({ isShowing }) =>
  isShowing
    ? ReactDOM.createPortal(
      <React.Fragment>
        <div className="custom-modal-overlay" />
        <div
          className="custom-modal-wrapper"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="custom-modal" style={{ width: "fit-content", backgroundColor: "transparent" }}>
            <div className="custom-modal-header">
            </div>
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <div className="custom-model-content">
            </div>
          </div>
        </div>
      </React.Fragment>,
      document.body
    )
    : null;

export default LoadingOverlay;
